"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectZoneList = selectZoneList;
exports.selectActiveZoneNumber = selectActiveZoneNumber;
exports.selectZone = selectZone;
exports.selectActiveZoneId = selectActiveZoneId;
exports.selectActiveZone = selectActiveZone;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.ZONE_MODULE_NAME];
}

function selectZoneState(state) {
  return selectModule(state).zone;
}

function selectZoneList(state) {
  return selectZoneState(state).data;
}

function selectZone(state, id) {
  return selectZoneList(state)[id];
}

function selectActiveZoneId(state) {
  return selectZoneState(state).activeZone;
}

function selectActiveZone(state) {
  return selectZone(state, selectActiveZoneId(state));
}

function selectActiveZoneNumber(state) {
  var activeZone = selectActiveZone(state);
  return activeZone && activeZone.number;
}